<template>
   <div id="perInfo">
       <ul>
           <li class="avator">
             <a href="javascript:;"><span>头像</span><img :src="this.profile" alt=""></a>
            </li>
            <li class="name">
                <a href="javascript:;"><span>昵称</span><strong>{{this.nickName }}</strong></a>
            </li>
            <li class="tel">
                <a href="javascript:;" @click="toChangeTel" ><span>手机号</span><strong>{{this.phone}}<i><img class="right right1" src="/static/img/rightArr.png"></i></strong></a>
            </li>
       </ul>
        <div>
          <li class="house">
            <a href="javascript:;" @click="toHouseInfo"><span>房产信息</span><i><img class="right right2" src="/static/img/rightArr.png"></i></a>
          </li>
        </div>
   </div>
</template>
<script>
export default {
  data () {
    return {
      nickName : sessionStorage.getItem('nickName '),
      phone: sessionStorage.getItem('phone'),
      profile: sessionStorage.getItem('profile')
    }
  },
  mounted(){
    let url = sessionStorage.getItem('home') || sessionStorage.getItem('action')
    if(url === 'homePageQingMeng'){
      const _this = this
      _this.postRequest('user/currentUserDetail ', {},function (data) {
        _this.nickName  = data.nickName
        _this.profile = data.profilePhoto
        sessionStorage.setItem('nickName ', data.nickName)
        sessionStorage.setItem('profile', data.profilePhoto)
        sessionStorage.setItem('phone', data.phone)
        sessionStorage.setItem('id', data.id)
      })
    }
  },
  methods: {
    toChangeTel () {
      this.$router.push({name: 'checkTel'})
    },
    toHouseInfo () {
      this.$router.push({name: 'houseInfo'})
    }
  }
}
</script>
<style scoped>
strong{
    color:#999;
}
.right{
  width: 12px;
  height: 21px;
}
.right1{
    padding-right: 26px;
}
.right2{
  padding-right: 10px;
}
#perInfo{
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    background-color: #F6F6F6;
}
#perInfo ul{
    width: 100%;
    padding:40px 26px 0;
    box-sizing: border-box;
    background-color: #fff;
}
#perInfo ul li{
  box-sizing: border-box;
  border-bottom: 1px solid #EFEFEF;
}
/* 头像显示 */
#perInfo ul .avator{
    height: 189px;
    line-height: 189px;
}
#perInfo ul .avator a{
    display: inline-block;
    width: 100%;
}
#perInfo ul .avator span{
    float: left;
    font-size: 30px;
}
#perInfo ul .avator img{
    float:right;
    width: 148px;
    height: 148px;
    border-radius: 50%;
}
/* 用户名 */
#perInfo .name{
    height: 90px;
    line-height: 90px;
    background-color: #fff;
    font-size: 30px;
}
#perInfo .name a{
    display: inline-block;
    width: 720px;
    height: 100%;
}
#perInfo .name a strong{
    font-weight:400;
    float: right;
  margin-right: 6%;
}
#perInfo .name a strong i{
    margin-left: 25px;
    font-size: 30px;
}
#perInfo .name a span{
    float: left;
}
/* 手机号 */
#perInfo .tel{
    height: 90px;
    line-height: 90px;
    background-color: #fff;
    font-size: 30px;
}
#perInfo .tel a{
    display: inline-block;
    width: 720px;
    height: 100%;
}
#perInfo .tel a strong{
    font-weight:400;
    float: right;
}
#perInfo .tel a strong i{
    margin-left: 15px;
    font-size: 30px;
}
#perInfo .tel a span{
    float: left;
}
/* 房产信息 */
#perInfo .house{
    height: 90px;
    line-height: 90px;
    background-color: #fff;
    font-size: 30px;
    margin-top: 20px;
}
#perInfo .house a{
    display: inline-block;
    width: 94%;
    height: 100%;
}
#perInfo .house a  i{
    float: right;
    margin-left: 5px;
    font-size: 30px;
}
#perInfo .house a span{
    float: left;
}
</style>



// WEBPACK FOOTER //
// src/components/pub-component/my/personInfo.vue